import { FC, ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { FacesDetailsStyled } from './style';
type FaceDetailsProps = {
  name: string;
  position: string;
  desc: ReactNode | string;
  img: string;
};
const FacesDetails: FC<FaceDetailsProps> = ({ desc, img, name, position }) => {
  const theme = useTheme();

  return (
    <FacesDetailsStyled>
      <div className="profile">
        <div>
          <img src={img} alt="faces" className="img" />
        </div>
        <div>
          <Typography variant="title">{name}</Typography>
          <Typography variant="title" style={{ color: theme.colors.primary }}>
            {position}
          </Typography>
        </div>
      </div>
      <div className="background">
        <Typography>{desc}</Typography>
      </div>
    </FacesDetailsStyled>
  );
};

export default FacesDetails;
